/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["elSurface"] }] */
import { useRef, useState, useCallback } from 'react'

export default function useCorrectPosition(contentPadding: number, prefer?: 'rightCenter') {
  const buttonRef = useRef<HTMLElement | null>(null)
  const surfaceRef = useRef<HTMLElement | null>(null)
  const buttonCopyRef = useRef<HTMLElement | null>(null)
  const [appear, setAppear] = useState(false) // выход из opacity 0

  const handleSurfaceRef = useCallback((elSurface: HTMLElement | null) => {
    surfaceRef.current = elSurface
    const elOpenLink = buttonRef.current
    const elOpenLinkCopy = buttonCopyRef.current
    if (elSurface && elOpenLink) {
      const {
        top: openLinkTop,
        bottom: openLinkBottom,
        right: openLinkRight,
        left: openLinkLeft,
      } = elOpenLink ? elOpenLink.getBoundingClientRect() : ({} as DOMRect)

      const {
        left: surfaceLeft,
        top: surfaceTop,
        right: surfaceRight,
        bottom: surfaceBottom,
      } = elSurface ? elSurface.getBoundingClientRect() : ({} as DOMRect)

      const dx = 10
      const dy = 10
      const admission = 30 // допуск на сколько можно выйти за нижний край окна браузера

      const surfaceWidth = surfaceRight - surfaceLeft
      const surfaceHeight = surfaceBottom - surfaceTop

      if (document.documentElement) {
        // проверка, умещается ли в видимую область
        // -> по вертикали
        if (
          elSurface &&
          openLinkTop + surfaceHeight - admission < document.documentElement.clientHeight
        ) {
          // умещается
          elSurface.style.top = `${openLinkTop - dy}px`
          if (elOpenLinkCopy) {
            elOpenLinkCopy.style.top = `${-contentPadding + dy}px`
          }
        } else {
          // не умещается, выпадение вверх
          elSurface.style.top = `${openLinkBottom - surfaceHeight + dy}px`
          if (elOpenLinkCopy) {
            elOpenLinkCopy.style.bottom = `${-contentPadding + dy}px`
          }
        }

        if (prefer === 'rightCenter') {
          const viewportWidth = document.documentElement.clientWidth
          const viewportHeight = document.documentElement.clientHeight
          // Вертикально центрируем относительно кнопки
          let top = openLinkTop + (openLinkBottom - openLinkTop) / 2 - surfaceHeight / 2
          // Сначала пытаемся открыть вправо
          let left = openLinkLeft - dx
          let isRight = true
          // Если справа не помещается — открываем влево
          if (left + surfaceWidth > viewportWidth) {
            left = openLinkRight - surfaceWidth + dy + contentPadding
            isRight = false
          }
          // Не выходим за границы viewport по вертикали
          top = Math.max(0, Math.min(top, viewportHeight - surfaceHeight))
          elSurface.style.top = `${top}px`
          elSurface.style.left = `${left}px`
          if (elOpenLinkCopy) {
            if (isRight) {
              elSurface.dataset.direction = 'right'
              elOpenLinkCopy.style.left = `${-contentPadding + dx}px`
              elOpenLinkCopy.style.right = ''
            } else {
              elSurface.dataset.direction = 'left'
              elOpenLinkCopy.style.right = `${-contentPadding + dx}px`
              elOpenLinkCopy.style.left = ''
            }
            const opeLinkHeight = openLinkBottom - openLinkTop
            elOpenLinkCopy.style.top = `${(surfaceHeight - 2 * contentPadding) / 2 - opeLinkHeight / 2}px`
            elOpenLinkCopy.style.bottom = ''
          }
        }

        if (prefer !== 'rightCenter') {
          // -> по горизонтали (слева)
          if (elSurface && openLinkRight + dx - surfaceWidth > 0) {
            // не умещается, выпадение влево
            elSurface.style.left = `${openLinkRight - surfaceWidth + dx}px`
            if (elOpenLinkCopy) {
              elOpenLinkCopy.style.right = `${-contentPadding + dx}px`
            }
          } else {
            // умещается
            elSurface.style.left = `${openLinkLeft - dx}px`
            if (elOpenLinkCopy) {
              elOpenLinkCopy.style.left = `${-contentPadding + dx}px`
            }
          }
        }

        setAppear(true)
      }
    }
    // setAppear(false)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    buttonRef,
    surfaceRef: handleSurfaceRef,
    buttonCopyRef,
    classes: { appear },
  }
}
